export default "__VITE_ASSET__De9p0S4d__"